export const hasPermission = {
  install(Vue) {
    Vue.directive('hasPermission', {
      bind(el, binding, vnode) {
        const permissionsNameList = JSON.parse(localStorage.getItem("permissionsList"));
        // 权限数据尚未加载时不做禁用处理，避免误禁所有按钮
        if (!permissionsNameList) {
          return;
        }
        const permissions = permissionsNameList
        const value = binding.value
        let flag = false
        // 如果后端返回按钮数组中包含当前标识 则显示按钮  不包含则移除或者隐藏按钮
        // 如果接口返回
        // value 按钮权限标识，permissions 是接口返回的所有按钮权限标识，
        // console.log('value',value);
        // console.log('typeof',typeof value);
        for (const v of value) {
          if (permissions.includes(v)) {

            flag = true
            // console.log('TRUE',flag);
          }
        }
        if (flag===false) {
          // 目前方案是 如果后端没有返回，那么需要隐藏，现在需要做的是，不隐藏但是需要置灰按钮
          // el.disabled=true
          el.disabled=true||'disabled';
          el.style.pointerEvents = 'none';
          // el.style.opacity =  0.5;
          // el.style.
          // console.log('FALSE',flag);
          // if (el.parentNode) {
          //   el.parentNode.removeChild(el)
          // } else {
          //   el.style.display = 'none'
          // }
          // el.disabled=true
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js